import { APP_INITIALIZER, NgModule, isDevMode } from '@angular/core';
import '@libs/flexible.js';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { PipesModule } from './pipes/pipes.module';
import { ComponentsModule } from '@comps/components.module';

import { httpInterceptor } from './core/interceptor/http-interceptor';
import { InitAppService } from '@services/common/init-app.service';
import { JSBridgeService } from './services/common/jsbridge.service';

import { configOptionsProvider } from '@libs/config/config-options';
import { trackingProvider } from '@libs/tracking';
import { platformDetectProvider } from '@libs/platform/platform-detect';
import { clientCookieProvider } from '@libs/client-cookie';

import { AppComponent } from './app.component';
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    PipesModule,
    ComponentsModule
  ],
  providers: [
    configOptionsProvider,
    platformDetectProvider,
    clientCookieProvider,
    trackingProvider,
    httpInterceptor,
    {
      provide: APP_INITIALIZER,
      useFactory: (initSer: InitAppService, bridgeSer: JSBridgeService) => async () => {
        try {
          await bridgeSer.initJsBridge();
          await initSer.initApp();
        } catch (err) {
          console.log('init module err..',err);
          return err;
        }
      },
      deps: [InitAppService, JSBridgeService],
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi())
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
